import { FC, SVGAttributes } from 'react';

type CherrySvgProps = SVGAttributes<SVGElement>;

export const CherrySvg: FC<CherrySvgProps> = (props) => {
    return (
        <svg
            width="41"
            height="42"
            viewBox="0 0 41 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <g style={{ mixBlendMode: 'multiply' }}>
                <path
                    d="M25.4833 23.3934C24.6062 22.3845 23.246 21.6309 21.1855 21.2344C19.2374 20.8585 14.8452 21.8994 13.71 27.5092C12.5749 33.1191 15.9505 38.2633 22.0342 39.437C28.118 40.6108 33.1891 37.3449 34.3727 31.4958C35.5562 25.6466 31.8571 23.2933 29.9089 22.9174C27.9889 22.546 26.6628 22.8261 25.4833 23.3934Z"
                    fill="#DB5311"
                />
            </g>
            <g style={{ mixBlendMode: 'multiply' }}>
                <path
                    d="M16.2752 13.2099C15.6513 12.1033 14.5272 11.1489 12.6809 10.3994C10.9363 9.69035 6.64053 9.86026 4.50696 14.9083C2.28242 20.1707 4.53544 25.3941 9.98395 27.6094C15.4327 29.8238 20.789 27.6935 23.0135 22.4311C25.1471 17.3831 22.2399 14.2848 20.4943 13.5756C18.7754 12.8756 17.4839 12.8949 16.2762 13.2101"
                    fill="#DB5311"
                />
            </g>
            <g style={{ mixBlendMode: 'multiply' }}>
                <path
                    d="M23.5132 24.7492C23.5132 24.7492 23.8597 18.2706 28.5044 13.0594C33.1492 7.8481 39.184 7.12511 39.184 7.12511C39.184 7.12511 30.4978 3.20676 23.43 5.61446C16.3621 8.02215 13.5595 14.6728 13.5595 14.6728"
                    stroke="#10B5A8"
                    strokeWidth="2.39146"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};
